import { ChevronDownIcon } from "lucide-react"
import { useState } from "react"
import { useOrganization } from "~/hooks/useOrganization"
import { EntityIdentity } from "~/components/EntityIdentity"
import { cn } from "~/lib/utils"
import { api } from "~/trpc/react"
import { OrgSwitcher } from "../OrgSwitcher"
import { Button } from "../ui/button"
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover"

export const OrgSelector = () => {
	const [open, setOpen] = useState(false)
	const { organization } = useOrganization()
	const { data: orgs } = api.user.getOrgs.useQuery()

	return (
		<Popover open={open} onOpenChange={setOpen}>
			<PopoverTrigger asChild>
				<Button
					variant="picker-outline"
					aria-expanded={open}
					aria-label="Select an organization"
					className="w-full min-w-0"
					size="lg"
					shape="rounded"
				>
					<span className="flex w-full min-w-0 items-center gap-2">
						<EntityIdentity
							kind="organization"
							name={organization?.name ?? "Loading..."}
							image={organization?.logo}
							className="grow"
						/>
						<ChevronDownIcon
							className={cn(
								"size-4 shrink-0",
								open ? "rotate-180" : "rotate-0"
							)}
						/>
					</span>
				</Button>
			</PopoverTrigger>
			<PopoverContent align="start">
				<OrgSwitcher
					orgs={orgs ?? []}
					withInput
					withCreate
					onNavigate={() => setOpen(false)}
				/>
			</PopoverContent>
		</Popover>
	)
}
